import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {
    1: { // Exercise num
        unit: 'Unit 8',
        id: 'SB5-V2-U8-P59-E1',
        audio: 'img/FriendsPlus/Page58/Audio/audio-e2-p58.mp3',
        video: 'img/FriendsPlus/Page58/Videos/e2.p58.mp4',
        component: UI,
        recorder: true,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page59/E1/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page58/E2/4.jpg', audioUrl: 'img/FriendsPlus/Page58/Audio/hinh1-e2-p58.mp3' },
                { url: 'img/FriendsPlus/Page58/E2/5.jpg', audioUrl: 'img/FriendsPlus/Page58/Audio/hinh2-e2-p58.mp3' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page58/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page58/Audio/hinh3-e2-p58.mp3' },
                { url: 'img/FriendsPlus/Page58/E2/7.jpg', audioUrl: 'img/FriendsPlus/Page58/Audio/hinh4-e2-p58.mp3' },

            ]
        ]
    },
    2: { // Exercise num
        unit: 'Unit 8',
        id: 'SB5-V2-U8-P59-E2',
        audio: 'img/FriendsPlus/Page59/Audio/audio-e2-p59.mp3',
        video: '',
        component: UI,
        recorder: true,
        exerciseKey: 'img/FriendsPlus/Page59/E1/Key/1.png',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page59/E2/1.jpg' },
                { url: 'img/FriendsPlus/Page59/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page59/Audio/tieude-e2-p59.mp3' },
                { url: 'img/FriendsPlus/Page59/E2/3.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page59/E2/4.jpg' },

            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page59/E2/5.jpg' },
                { url: 'img/FriendsPlus/Page59/E2/6.jpg' },
                { url: 'img/FriendsPlus/Page59/E2/7.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page59/E2/8.jpg' },
                { url: 'img/FriendsPlus/Page59/E2/9.jpg' },
                { url: 'img/FriendsPlus/Page59/E2/10.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page59/E2/11.jpg' },
            ],

        ]
    },
    3: { // Exercise num
        unit: 'Unit 8',
        id: 'SB5-V2-U8-P59-E3',
        audio: '',
        video: '',
        component: D1,
        checkDuplicated: true,
        exerciseKey: 'img/FriendsPlus/Page59/E3/Key/answerKey.png',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page59/E3/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page59/E3/2.jpg' },
                { url: 'img/FriendsPlus/Page59/E3/3.jpg', input: true, answer: "a cookie/an egg/a melon/an orange" },
                { url: 'img/FriendsPlus/Page59/E3/4.jpg' },
                { url: 'img/FriendsPlus/Page59/E3/5.jpg', input: true, answer: "some bread/some rice/some water/some juice" },
                { url: 'img/FriendsPlus/Page59/E3/6.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page59/E3/7.jpg' },
                { url: 'img/FriendsPlus/Page59/E3/8.jpg', input: true, answer: "a cookie/an egg/a melon/an orange" },
                { url: 'img/FriendsPlus/Page59/E3/9.jpg' },
                { url: 'img/FriendsPlus/Page59/E3/10.jpg', input: true, answer: "some bread/some rice/some water/some juice" },
                { url: 'img/FriendsPlus/Page59/E3/11.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page59/E3/12.jpg' },
                { url: 'img/FriendsPlus/Page59/E3/13.jpg', input: true, answer: "a cookie/an egg/a melon/an orange" },
                { url: 'img/FriendsPlus/Page59/E3/14.jpg' },
                { url: 'img/FriendsPlus/Page59/E3/15.jpg', input: true, answer: "some bread/some rice/some water/some juice" },
                { url: 'img/FriendsPlus/Page59/E3/16.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page59/E3/17.jpg' },
                { url: 'img/FriendsPlus/Page59/E3/18.jpg', input: true, answer: "a cookie/an egg/a melon/an orange" },
                { url: 'img/FriendsPlus/Page59/E3/19.jpg' },
                { url: 'img/FriendsPlus/Page59/E3/20.jpg', input: true, answer: "some bread/some rice/some water/some juice" },
                { url: 'img/FriendsPlus/Page59/E3/21.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page59/E3/22.jpg' },
            ],


        ]
    },
    4: { // Exercise num
        unit: 'Unit 8',
        id: 'SB5-V2-U8-P59-E4',
        audio: '',
        video: '',
        component: D1,
        exerciseKey: 'img/FriendsPlus/Page59/E4/Key/answerKey.png',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page59/E4/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page59/E4/2.jpg' },
                { url: 'img/FriendsPlus/Page59/E4/3.jpg', input: true, answer: "some" },
                { url: 'img/FriendsPlus/Page59/E4/4.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page59/E4/5.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page59/E4/6.jpg' },
                { url: 'img/FriendsPlus/Page59/E4/7.jpg', input: true, answer: "some" },
                { url: 'img/FriendsPlus/Page59/E4/8.jpg' },
                { url: 'img/FriendsPlus/Page59/E4/9.jpg', input: true, answer: "an" },
                { url: 'img/FriendsPlus/Page59/E4/10.jpg' },
            ],

        ]
    },
    5: { // Exercise num
        unit: 'Unit 8',
        id: 'SB5-V2-U8-P59-E5',
        audio: '',
        video: '',
        component: UI,
        recorder: true,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page59/E5/1.jpg' },
            ]
        ]
    },
}
export default json